var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full md:w-1/2 lg:w-1/4 p-3"},[_c('panel',{staticClass:"flex flex-col items-center justify-around h-64"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }